import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
} from '@mui/material';
import {
  PersonAdd as PersonAddIcon,
  Person as PersonIcon,
  PersonRemove as PersonRemoveIcon,
  Folder as FolderIcon,
  Assessment as AssessmentIcon,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (!user) return <div>Loading...</div>;



  const adminModules = [
    {
      title: 'Onboarding Management',
      description: 'Manage employee onboarding processes, track progress, and oversee induction activities.',
      icon: <PersonAddIcon color="primary" sx={{ fontSize: 40 }} />,
      path: '/admin/onboarding',
    },
    {
      title: 'Employee Management',
      description: 'View and manage existing employees, their documents, training records, and feedback.',
      icon: <PersonIcon color="primary" sx={{ fontSize: 40 }} />,
      path: '/admin/employees',
    },
    {
      title: 'Offboarding Management',
      description: 'Oversee employee offboarding processes, asset returns, and exit interviews.',
      icon: <PersonRemoveIcon color="primary" sx={{ fontSize: 40 }} />,
      path: '/admin/offboarding',
    },
    {
      title: 'Document Management',
      description: 'Upload, organize, and manage company documents with proper categorization and access control.',
      icon: <FolderIcon color="primary" sx={{ fontSize: 40 }} />,
      path: '/admin/documents',
    },
    {
      title: 'Performance Management',
      description: 'Create and manage performance review cycles, forms, and view approved performance reviews with calculated scores.',
      icon: <AssessmentIcon color="primary" sx={{ fontSize: 40 }} />,
      path: '/admin/performance-management',
    },
    {
      title: 'Performance Reviews',
      description: 'View all approved performance reviews, analyze scores, and generate performance reports.',
      icon: <AssessmentIcon color="primary" sx={{ fontSize: 40 }} />,
      path: '/admin/performance-reviews',
    },
  ];

  return (
    <Box sx={{ bgcolor: 'background.default', pl: 2 }}>

      <Container maxWidth={false} disableGutters sx={{ width: '100%' }}>
        <Box sx={{ mb: 4, mt: 2 }}>
          <Typography gutterBottom sx={{ fontWeight: 600, color: 'text.primary', letterSpacing: 1, fontSize: '30px' }}>
            Welcome, {user.firstName} {user.lastName}, to Divergent Insights!
          </Typography>
          <Typography variant="h5" color="text.secondary" gutterBottom sx={{ fontStyle: 'italic', fontWeight: 400, fontSize: '20px' }}>
          Creating Value Through Collaboration.
          </Typography>
          <br />
        
          <Typography variant="body1" sx={{ mt: 1, fontSize: '14px', mb: 3, fontWeight: 600, color: 'text.secondary', letterSpacing: 0.5, fontStyle: 'italic' }}>
            Select a module from the sidebar to get started
          </Typography>
        </Box>

        <Grid container spacing={4} alignItems="stretch">
          {adminModules.map((module) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              key={module.title}
              sx={{ display: 'flex', minWidth: { xs: '100%', sm: '100%', md: 320 } }}
            >
              <Card
                sx={{
                  flex: 1,
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  p: { xs: 2, sm: 3 },
                  minHeight: 360,
                  borderRadius: 3,
                  boxShadow: 2,
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-6px) scale(1.03)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: 72,
                      height: 72,
                      borderRadius: '50%',
                      background: 'rgba(126,87,194,0.12)',
                      mb: 2,
                    }}
                  >
                    {React.cloneElement(module.icon, { sx: { fontSize: 44, color: '#7e57c2' } })}
                  </Box>
                  <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mb: 3, fontSize: '20px' }}>
                    {module.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 3, fontSize: '16px', lineHeight: 1.6 }}
                  >
                    {module.description}
                  </Typography>
                </CardContent>
                                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(module.path)}
                    sx={{
                      fontWeight: 700,
                      letterSpacing: 0.5,
                      borderRadius: 2,
                      fontSize: '14px',
                      px: 4,
                      py: 1.5,
                      textTransform: 'none',
                      alignSelf: 'center',
                      mb: 2,
                    }}
                  >
                    {module.title === 'Employee Management'
                      ? 'View Employee Management'
                      : `Manage ${module.title}`}
                  </Button>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AdminDashboard; 